/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 26/03/2025 - 13:27:07
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 26/03/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useEffect, useState } from "react";
import Navbar from "../../components/shared/navbar";
import Footer from "../../components/shared/footer";
import images from "../../images/index";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../../firebase";
import TrashCards from "../../components/pages/trashCards";
import { useTranslation } from 'react-i18next';

const Trash: React.FC = () => {
  const { t } = useTranslation(['trashPage', 'common']);
  const [data, setData] = useState([{}]);
  const [searchValue, SetSearchValue] = useState("");
  const [render, setRender] = useState(true);
  const user = auth.currentUser?.uid;
  const handleStatusChange = () => {
    setRender((prevRender) => !prevRender);
  };

  // To get deleted projects and search from trash projects
  useEffect(() => {
    const fetchData = async () => {
      if (user) {
        let q;

        if (searchValue.trim() === "") {
          q = query(
            collection(db, "projects"),
            where("userId", "==", user),
            where("status", "==", "trash")
          );
        } else {
          q = query(
            collection(db, "projects"),
            where("userId", "==", user),
            where("status", "==", "trash"),
            where("projectName", ">=", searchValue),
            where("projectName", "<=", searchValue + "\uf8ff")
          );
        }

        const querySnapshot = await getDocs(q);
        const newData = querySnapshot.docs.map((doc) => {
          return { ...doc.data(), id: doc.id };
        });

        setData(newData);
      }
    };

    fetchData();
  }, [searchValue, user, render]);
  return (
    <React.Fragment>
      <Navbar />
      <div className="my-4 d-flex align-items-end ">
        <Link
          style={{ width: "fit-content", position: "absolute" }}
          className="text-decoration-none"
          to="/dashboard"
        >
          <div className="mx-3  d-flex align-items-center">
            <Image className="mb-3" src={images.leftArrow} alt="back_arrow" />
            <p className="d-none d-sm-inline  mx-2 backToDashboard">
              {t('trashPage:Dashboard')}
            </p>
          </div>
        </Link>
        <h1 className="newProjects  mx-auto ">{t('trashPage:Trash')}</h1>
      </div>
      <div className="d-block d-sm-flex justify-content-between mx-4  mt-3">
        <div className="d-flex justify-content-between align-items-center mt-2">
          <span>{t('trashPage:sortBy')} </span>
          <img src={images.ChevronDown} alt="chevron_down" />
        </div>
        <div className="mt-3 searchDiv">
          <img src={images.SearchIcon} alt="Search Icon" className="searchIcon" />
          <input
            className="activeSearch"
            type="text"
            placeholder={t('trashPage:search')}
            onChange={(e) => {
              const value = e.target.value.trim().toLocaleLowerCase();
              SetSearchValue(value);
            }}
          />
        </div>
      </div>
      {data.length > 0 ? (
        <Container fluid className="my-5">
          <Row style={{ marginBottom: "180px" }} className="gy-3 ">
            {data?.map((value: any) => {
              return (
                <Col key={value.projectName} xl={3} lg={4} md={5} sm={6}>
                  <TrashCards
                    onStatusChange={handleStatusChange}
                    data={value}
                  />
                </Col>
              );
            })}
          </Row>
        </Container>
      ) : (
        <div className="text-center nothingToShow">
          <h2>{t('trashPage:noResults')}</h2>
        </div>
      )}
      <Footer />
    </React.Fragment>
  );
};

export default Trash;